import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Container
} from '@mui/material';
import {
  Security as SecurityIcon,
  Home as HomeIcon,
  Logout as LogoutIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const NoAccess = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserId');
    localStorage.removeItem('currentUserPermissions');
    navigate('/admin');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: 3,
            maxWidth: 500,
            width: '100%'
          }}
        >
          <SecurityIcon
            sx={{
              fontSize: 80,
              color: 'error.main',
              mb: 3
            }}
          />
          
          <Typography
            variant="h4"
            component="h1"
            color="error.main"
            gutterBottom
            sx={{ fontWeight: 600 }}
          >
            Access Denied
          </Typography>
          
          <Typography
            variant="h6"
            color="text.secondary"
            gutterBottom
            sx={{ mb: 3 }}
          >
            You don't have permission to access the admin panel
          </Typography>
          
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, lineHeight: 1.6 }}
          >
            Your account doesn't have the necessary permissions to access any administrative functions. 
            Please contact your system administrator to request access or to have your permissions updated.
          </Typography>
          
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}
          >
            <Button
              variant="outlined"
              startIcon={<HomeIcon />}
              onClick={handleGoHome}
              size="large"
              sx={{
                borderRadius: 2,
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Go to Website
            </Button>
            
            <Button
              variant="contained"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              size="large"
              sx={{
                borderRadius: 2,
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Logout
            </Button>
          </Box>
          
          <Box
            sx={{
              mt: 4,
              p: 3,
              bgcolor: 'info.50',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'info.200'
            }}
          >
            <Typography
              variant="body2"
              color="info.main"
              sx={{ fontWeight: 500 }}
            >
              <strong>Need Help?</strong> If you believe you should have access, 
              please contact your system administrator with your username and the 
              reason for your access request.
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default NoAccess;
